module.exports = __webpack_public_path__ + "static/img/72074B_1_R_20221217_LC.b89e7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72074B_1_R_20221217_LC.png
// module id = q1dl
// module chunks = 0